import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, Col, Form, Row, message, Input, InputNumber, Switch } from 'antd'

import UserSearch from '../../components/UserSearch'
import ActivitySearch from '../../components/ActivitySearch'
import ReviewService from '../../network/services/review'

const ReviewForm = ({
  form = null,
  initialValue = null,
  isLoading = null,
  setIsLoading = null,
  refresh
}) => {
  const navigate = useNavigate()

  const handleSubmit = async (values) => {
    if (isLoading) return
    setIsLoading(true)

    if (initialValue?.id) {
      try {
        const { data: result } = await ReviewService.update(initialValue.id, values)
        if (result.success) {
          message.success('Update successful')
          refresh()
        }
      } catch (error) {
        message.error('Update review error ' + error.message)
      }
    } else {
      try {
        const { data: result } = await ReviewService.create(values)
        if (result.success) {
          message.success('Create successful')
          navigate(`/dashboard/reviews/${result.data.id}`)
        }
      } catch (error) {
        message.error('Create review error ' + error.message)
      }
    }

    setIsLoading(false)
  }

  useEffect(() => {
    form.resetFields()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  return (
    <>
      <Form
        form={form}
        name="new-review"
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{
          ...initialValue,
          condition_match: initialValue == null ? 'all' : initialValue.condition_match,
          sort_order: initialValue == null ? 'ascending' : initialValue.sort_order
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
            <Card bordered={false}>
              <Form.Item name="title" label="Title">
                <Input />
              </Form.Item>

              <Form.Item name="content" label="Content">
                <Input />
              </Form.Item>

              <ActivitySearch
                label="Activity"
                name="activity_id"
                searchKey="name"
                rules={[{ required: true, message: 'Please select an activity!' }]}
              />

              <UserSearch
                label="User"
                name="user_id"
                searchKey="email"
                rules={[{ required: true, message: 'Please select a user!' }]}
              />

              <Form.Item name="score" label="Score">
                <InputNumber max={5} min={1} />
              </Form.Item>

              <Form.Item name="more_activity" valuePropName="checked" label="Want more activities">
                <Switch />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default ReviewForm
